import Lock from "rialto-icons/Lock";
import AllAgents from "rialto-icons/ShareStatusAll";
import MeClient from "rialto-icons/ShareStatusBrokerOwnerTeam";
import MeTeam from "rialto-icons/ShareStatusBrokerTeamOwnerTeam";
import Custom from "rialto-icons/ShareStatusCustom";

const shareStatusIcon = (status) => {
  const icons = {
    all: () => AllAgents,
    owner_team: () => Lock,
    broker_owner_team: () => MeClient,
    broker_team_owner_team: () => MeTeam,
    custom: () => Custom,
    default: () => Custom,
  };

  return (icons[status] || icons.default)();
};

export default shareStatusIcon;
